import { Component, OnInit, OnDestroy, inject, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MessageModule } from "primeng/message";
import { AlertService } from "../../services/alert.service";
import { Subscription } from "rxjs";

// Tipo personalizzato per i messaggi
export interface AlertMessage {
  severity: "success" | "info" | "warn" | "error";
  detail: string;
}

/**
 * Componente per mostrare alert/notifiche eleganti
 * Utilizza PrimeNG Message per un'esperienza utente migliore
 * Si integra automaticamente con AlertService
 */
@Component({
  selector: "ape-alert",
  standalone: true,
  imports: [CommonModule, MessageModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./ape-alert.component.html"
})
export class ApeAlertComponent implements OnInit, OnDestroy {
  private alertService = inject(AlertService);

  private subscription?: Subscription;

  message: AlertMessage | null = null;

  visible: boolean = false;

  ngOnInit(): void {
    this.subscription = this.alertService.alert$.subscribe((alert: { message: AlertMessage | null;
      visible: boolean; }) => {
      this.message = alert.message;
      this.visible = alert.visible;
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  /**
   * Gestisce la chiusura dell'alert
   */
  onClose(): void {
    this.alertService.hide();
  }
}
